export default __webpack_public_path__ + "static/media/trash-alt-solid.0726a0cf.svg";